import { atom } from "recoil";
import Accommodation from "../models/Accommodation";

export const profileState = atom<Array<Accommodation>>({
  key: "profileState",
  default: [],
});
